export default "__VITE_ASSET__DOZmPk5b__"